import { render, staticRenderFns } from "./CommentsTableItem.vue?vue&type=template&id=0d9085b0"
import script from "./CommentsTableItem.vue?vue&type=script&lang=js"
export * from "./CommentsTableItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports